/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { Controller } from "stimulus";

export default class ModalController extends Controller<HTMLDialogElement> {
	connect() {
		this.element.addEventListener(
			"turbo:before-morph-attribute",
			this.handleAttributeMorph as any
		);
	}

	handleAttributeMorph = (e: MouseEvent) => {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		const detail = e.detail as unknown as Record<string, unknown>;
		if (detail.attributeName == "data-open" && detail.mutationType == "update") {
			requestAnimationFrame(() => {
				if (!this.element.open) {
					this.element.showModal();
				}
			});
		}
	};

	disconnect() {
		this.element.removeEventListener(
			"turbo:before-morph-attribute",
			this.handleAttributeMorph as any
		);
	}
}
